import { motion } from "framer-motion"
import {ChevronDown, Sparkles} from 'lucide-react'

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.lumi.new/66/66d6a2eb489b89ec4bf647b474133f04.png"
          alt="Bling Skins luxury gaming cosmetics hero background"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/60" />
      </div>

      {/* Decorative gold lines */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-yellow-600/50 to-transparent" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 text-center">
        {/* Badge */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-yellow-700/40 bg-yellow-900/20 mb-8"
        >
          <Sparkles className="w-4 h-4 text-yellow-500" />
          <span className="text-yellow-400 text-xs sm:text-sm font-semibold uppercase tracking-widest">
            Premium Gaming Aesthetics
          </span>
        </motion.div>

        {/* H1 — Primary SEO keyword */}
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="text-4xl sm:text-6xl lg:text-8xl font-black uppercase tracking-tight leading-none mb-6"
          style={{ fontFamily: "'Orbitron', sans-serif" }}
        >
          <span className="text-white">The Ultimate Guide to</span>
          <br />
          <span className="gold-shimmer glow-gold-text">Bling Skins</span>
        </motion.h1>

        {/* Sub-headline */}
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="text-gray-400 text-lg sm:text-xl lg:text-2xl max-w-2xl mx-auto mb-10 font-light"
        >
          Level up your gaming aesthetic with the rarest gold, diamond, and prestige skins.
        </motion.p>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.45 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <a
            href="#featured-games"
            className="group inline-flex items-center gap-3 px-8 py-4 rounded-xl gold-shimmer-bg text-black font-bold text-base sm:text-lg uppercase tracking-wider transition-all hover:scale-105 hover:shadow-xl hover:shadow-yellow-500/25"
          >
            Explore the Best Bling Skins
            <Sparkles className="w-5 h-5 group-hover:rotate-12 transition-transform" />
          </a>
          <a
            href="#value-prop"
            className="inline-flex items-center gap-2 px-6 py-4 rounded-xl border border-gray-700 text-gray-300 hover:text-yellow-400 hover:border-yellow-700/50 font-semibold text-base uppercase tracking-wider transition-all"
          >
            Learn More
          </a>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 1.5, repeat: Infinity }}
        >
          <ChevronDown className="w-6 h-6 text-yellow-600/60" />
        </motion.div>
      </motion.div>
    </section>
  )
}
